// Catatan pembaruan (owner 2026-10-17, VERSI-APLIKASI): what changed per version, in plain
// words for every role. Pure data + helpers (no imports) so Jest can check it against VERSI.
//
// Aturan nomor (CLAUDE.md 3.3): fitur baru → angka kedua naik (2.8 → 2.9 → 2.10), perbaikan saja →
// angka ketiga naik (2.9 → 2.9.1), perubahan besar → angka pertama naik (3.0). Entri terbaru di atas.
// Riwayat disusun ulang owner 2026-10-17: 1.0 = rilis awal (7 Okt), 2.0 = tampilan baru SOQPRINT (10 Okt),
// … 2.8 = transfer kas (17 Okt malam). Halaman ini mulai dari 2.0; 1.x dicatat di docs/rencana/VERSI-APLIKASI.md.
// Setiap paket yang akan di-push WAJIB: naikkan file VERSI + tambah entri di sini (test menjaga keduanya sama).

export const CATATAN = [
  {
    versi: "2.24.3",
    tanggal: "2026-11-04",
    judul: "Catatan upah tanpa tarif bisa ditandai \"diselesaikan lewat Penyesuaian\"",
    untuk: "Owner, Finance",
    butir: [
      "Catatan upah penjahit yang masih \"TARIF BELUM ADA\" (Rp0) tetapi sudah dibayar lewat Penyesuaian Owner sebelumnya menghalangi penguncian minggu. Kini Owner bisa menandainya di rincian penjahit (menu Borongan): alasan wajib, tercatat di audit.",
      "Tanda itu berupa catatan susulan Rp0, jadi tidak ada yang dibayar dua kali; catatan asli tidak diubah; menandai dua kali ditolak; Hitung ulang dan skrip koreksi tidak akan membayar catatan itu lagi. Aturan Kunci periode tidak berubah.",
    ],
  },
  {
    versi: "2.24.2",
    tanggal: "2026-11-04",
    judul: "Koreksi upah penjahit bisa diulang bila tarif diputuskan lagi",
    untuk: "Owner, Finance",
    butir: [
      "Skrip koreksi upah jahit (pengelola) kini bisa menulis catatan koreksi kedua untuk catatan upah yang sudah pernah dikoreksi, misalnya saat tarif celana diputuskan berlaku sejak awal. Hanya selisih yang belum terkoreksi yang ditulis; catatan asli dan koreksi sebelumnya tidak diubah, tidak ada yang dihitung dua kali.",
      "Pemeriksaan tarif (hanya-baca) bisa membandingkan semua catatan dengan tarif yang baru diputuskan sebelum tarifnya dimasukkan, supaya Finance melihat dampaknya lebih dulu.",
    ],
  },
  {
    versi: "2.24.1",
    tanggal: "2026-11-03",
    judul: "Minggu borongan mulai hari yang diatur Owner (Minggu–Sabtu)",
    untuk: "Owner, Finance, penjahit",
    butir: [
      "Pengaturan baru \"Minggu borongan\": Owner memilih hari awal minggu upah penjahit (bawaan Senin–Minggu; toko memakai Minggu–Sabtu sesuai hitungan Finance). Rekap, kunci, bayar, dan Borongan saya mengikuti hari itu; label periode menampilkan nama harinya.",
      "Hari awal hanya bisa diubah selama belum ada minggu yang dikunci/dibayar. Catatan upah yang sudah ada diberi label minggu baru oleh pengelola lewat skrip migrasi (nilai tidak berubah, tercatat di audit).",
    ],
  },
  {
    versi: "2.24",
    tanggal: "2026-11-03",
    judul: "Rekap pcs per pos: masuk & selesai hari ini / bulan ini (Atasan, Celana, Kaos)",
    untuk: "Operator, Owner, Manager",
    butir: [
      "Di atas Antrean Produksi, setiap operator melihat \"Rekap pcs\" posnya sendiri: berapa pcs MASUK ke pos dan berapa pcs SELESAI, hari ini atau bulan ini, dipisah Atasan / Celana / Kaos, lengkap dengan daftar per SPK. Penjahit hanya melihat bagian yang dibagikan kepadanya.",
      "Owner dan Manager: tab baru \"Rekap pcs\" di menu Monitoring — tabel semua pos (klik baris pos untuk melihat SPK-nya), pilihan Hari ini / Bulan ini, pos, dan jenis pesanan.",
      "Satu pcs stelan dihitung 1 atasan + 1 celana. Pekerjaan yang kembali karena reject (rework) dihitung lagi sebagai masuk dan selesai di pos itu, ditandai \"rework ke-N\"; angka reject kecil tampil di samping jumlah selesai.",
      "Menu Barang (Owner): isian baru \"Dihitung di rekap pcs sebagai\" = Atasan / Celana / Stelan / Kaos / Tidak dihitung, dengan usulan otomatis. Barang yang belum diisi tampil sebagai \"Belum ditentukan\" di rekap, tidak dihitung diam-diam. Ikut di Download/Import Barang (kolom \"Rekap pcs\").",
    ],
  },
  {
    versi: "2.23",
    tanggal: "2026-10-31",
    judul: "Pesanan Jersey dipecah tanpa daftar nama + Lengkapi nama & nomor setelah ACC",
    untuk: "Kasir/CS, Owner",
    butir: [
      "Saat pesanan Jersey dipecah per desain, Bagian 4 menjadi tabel ukuran × desain: cukup isi jumlah per ukuran untuk setiap desain. Daftar nama (Bagian 3) boleh dikosongkan; bila diisi, harus cocok dengan tabel.",
      "Tombol baru \"Lengkapi nama & nomor\" di halaman pesanan Jersey: mengisi nama, nomor, lengan, dan catatan pemain setelah customer ACC — tanpa Ubah data, tanpa mengubah harga, tanpa membatalkan ACC customer. Jumlah per ukuran harus tetap sama; berlaku sampai ACC akhir kasir dan sebelum Pattern & Layout dimulai (nama dipakai di layout dan dicetak di Sublim).",
      "Petunjuk yang jelas di atas Bagian 3 saat pesanan dipecah. Selama nama belum dilengkapi, lembar kerja, Excel SPK, dan detail SPK menampilkan peringatan \"Rekap lengan belum ada, lengkapi nama dulu\".",
      "Catatan audit pengaturan file master: nilai isian lanjutan (harga per GB, kurs, batas atas bucket, dll.) hanya terlihat oleh Administrator; Owner lain melihat \"(hanya Administrator)\".",
    ],
  },
  {
    versi: "2.22.4",
    tanggal: "2026-10-30",
    judul: "Unggah banyak file master sekaligus",
    untuk: "Owner, Desain, Pattern",
    butir: [
      "Di bagian \"File master desain\" kini bisa memilih banyak file sekaligus, menekan \"Unggah folder\", atau menyeret file/folder ke kotaknya. Semua file masuk antrean dan diunggah satu per satu sampai habis; antrean boleh ditambah kapan saja.",
      "Kemajuan tampil di panel kecil di pojok kanan bawah: per file bisa Jeda, Lanjut, atau Batal, dan di akhir ada ringkasan berhasil, ditolak, dan dilewati beserta alasannya.",
      "Unggahan tetap berjalan saat pindah menu atau saat browser diperkecil. Jangan tutup tab/browser sampai selesai; bila tertutup, saat aplikasi dibuka lagi tekan \"Lanjutkan unggahan\" (di Chrome cukup tekan Izinkan).",
      "File sistem (misalnya Thumbs.db, desktop.ini) dan jenis yang tidak diizinkan dilewati otomatis. File RAR/ZIP tidak diterima: ekstrak dulu, lalu unggah foldernya.",
    ],
  },
  {
    versi: "2.22.3",
    tanggal: "2026-10-30",
    judul: "Upah penjahit: kerah dibaca dari nota, atasan tidak dihitung stelan",
    untuk: "Owner, Finance, Kasir/CS",
    butir: [
      "Kerah yang ditulis kasir di kolom \"Kerah\" nota kini ikut dibaca untuk upah penjahit, walau tidak dipilih di \"Kerah (upah jahit)\" dan tidak ada barang kerah di barang tambahan. Nama kerah yang tidak dikenal diberi peringatan saat membuat nota.",
      "Form Jersey menampilkan kerah mana yang dipakai untuk upah di bawah pilihan \"Kerah (upah jahit)\".",
      "Form Barang menjelaskan arti pilihan \"Upah jahit\": jersey atasan saja = tanpa jenis jahitan + centang \"kasir wajib memilih kerah\"; stelan = Celana Pendek + centang itu.",
      "Catatan upah yang sudah terlanjur salah (atasan dihitung stelan, kerah tidak terbaca) dirapikan Owner lewat skrip server: dicek dulu, lalu satu catatan koreksi per catatan upah dengan selisihnya; catatan asli tidak diubah.",
    ],
  },
  {
    versi: "2.22.1",
    tanggal: "2026-10-29",
    judul: "Pengaturan file master lebih ringkas",
    untuk: "Owner",
    butir: [
      "Kartu \"File master desain\" di Pengaturan kini hanya menampilkan yang perlu diatur Owner: status penyimpanan, jumlah GB tersimpan, lama simpan draf dan final, ukuran maksimal per file, batas unggah per akun per hari, versi maksimal per SPK, dan jenis file yang boleh.",
      "Pengaturan teknis penyimpanan diurus Administrator (iartech) di bagian \"Pengaturan lanjutan\".",
      "Di menu Users dan bilah atas, peran Owner kini tertulis \"Owner\".",
    ],
  },
  {
    versi: "2.22",
    tanggal: "2026-10-29",
    judul: "File master desain tersimpan di aplikasi",
    untuk: "Owner, Desain, Pattern, Manager, operator Sublim/DTF/Digital/Outdoor",
    butir: [
      "Di detail SPK (menu SPK, Antrean Produksi, dan detail Jersey) ada bagian \"File master desain\". Desain, Pattern, dan Owner bisa mengunggah file CorelDRAW, Illustrator, Photoshop, PDF, PNG, TIFF, JPG, atau EPS sampai 1 GB per file.",
      "File dikirim langsung dari browser dalam potongan kecil. Bila internet putus, tekan Jeda/Lanjut atau pilih file yang sama lagi: yang sudah terkirim tidak dikirim ulang.",
      "Setiap unggahan menjadi versi baru (v1, v2, …). Versi yang siap dicetak ditandai \"Final\"; operator mesin hanya melihat versi final dan tanda \"pakai ini\" ada di final terbaru.",
      "Isi file diperiksa: file yang namanya .pdf tetapi isinya bukan PDF (dan jenis lain yang tidak cocok) ditolak.",
      "Draf disimpan 30 hari dan versi final 365 hari, lalu dihapus otomatis. Owner bisa mengubah lama simpan, batas ukuran, jenis file, dan batas unggah per hari di Pengaturan → File master.",
      "Membatalkan tanda final dan menghapus versi hanya bisa dilakukan Owner dengan alasan, dan tercatat di riwayat.",
    ],
  },
  {
    versi: "2.21.2",
    tanggal: "2026-10-28",
    judul: "Panel lonceng rapi di HP",
    untuk: "Owner, Kasir/CS, Manager",
    butir: [
      "Di HP (termasuk iPhone), panel lonceng pemberitahuan sekarang selebar layar dengan jarak kecil di kiri dan kanan, tidak lagi terpotong di sisi kiri.",
      "Judul pemberitahuan yang panjang, misalnya \"Revisi selesai · SPK-…\" atau \"Lewat rencana\", turun ke baris berikutnya sehingga terbaca utuh.",
      "Daftar pemberitahuan digulir di dalam panel; halaman di belakangnya tidak ikut bergeser.",
      "Tampilan di komputer tidak berubah.",
    ],
  },
  {
    versi: "2.21.1",
    tanggal: "2026-10-26",
    judul: "Perbaikan keamanan dari pemeriksaan berkala",
    untuk: "Owner, Kasir/CS, penjahit, customer",
    butir: [
      "Login lebih aman: selain kunci lama (5 kali salah untuk satu username dari satu perangkat), sekarang ada kunci per alamat internet (bawaan 50 kali salah dalam 15 menit, karena semua perangkat toko memakai satu alamat) dan per username (bawaan 10 kali salah dalam 15 menit). Saat terkunci, password yang benar pun ditolak selama 15 menit. Owner bisa mengubah kedua angka di Pengaturan → Kunci login.",
      "Menu Users: akun yang terkunci bertanda \"Login terkunci s/d …\". Owner (dan Manager untuk akun karyawan) bisa menekan \"Buka kunci\" supaya akun itu bisa login lagi tanpa menunggu 15 menit. Tercatat di riwayat perubahan.",
      "Username lama dari akun yang diganti namanya tidak bisa dipakai akun lain.",
      "Password sementara yang dibuat atau direset Owner/Manager sekarang minimal 8 karakter.",
      "Unggah file (mockup, gambar referensi, logo, impor barang, impor stok) hanya diterima dari akun yang sudah login, dengan ukuran paling besar 16 MB. Kiriman yang lebih besar langsung ditolak.",
      "Logo toko hanya menerima gambar diam JPG, PNG, atau WebP.",
      "Nota digital customer hanya menampilkan nama kasir, tidak pernah nama login atau alamat e-mail. Akun tanpa nama menampilkan tanda \"—\".",
      "Penjahit hanya bisa membuka detail antrean dan mockup Jersey untuk bagian yang dibagikan kepadanya, sama seperti menu SPK.",
      "ACC & Mockup: status \"Mockup v1.0 dikirim\" memakai nomor versi yang dilihat customer.",
      "Pesan \"Terlalu banyak percobaan\" dan \"Kiriman terlalu besar\" tampil dengan bahasa yang jelas.",
    ],
  },
  {
    versi: "2.21",
    tanggal: "2026-10-26",
    judul: "Satu nota Jersey bisa dipecah per desain, dan desainer dipilih saat order dibuat",
    untuk: "Kasir/CS, Desain, Owner, Manager, operator Jersey, customer",
    butir: [
      "Form Jersey: setiap baris jersey dan barang tambahan bisa diberi Desain 1, Desain 2, … Satu desain = satu SPK sendiri dengan barang, nama & ukuran pemain, dan bahannya sendiri. Kalau semua baris Desain 1, hasilnya sama seperti dulu (satu SPK).",
      "Pesanan yang dipecah wajib mengisi daftar nama & ukuran untuk setiap pcs dan memilih variasinya (nama boleh kosong), supaya setiap SPK mendapat ukuran yang benar.",
      "Tagihan tetap satu nota: satu nomor nota, satu total, satu DP, satu invoice. Customer menyetujui mockup sekali untuk semua desain; halaman ACC menampilkan gambar per desain.",
      "Desain mengunggah mockup per desain (tombol Desain 1 / Desain 2 di ACC & Mockup). Antrean produksi, lembar kerja, dan detail SPK diberi tanda \"Desain 2 dari 2\" dan hanya menampilkan mockup desain itu.",
      "Pesanan baru tampil di Siap Diambil hanya setelah semua SPK nota itu selesai.",
      "Pembagian desain masih bisa diubah lewat Ubah data selama produksi dan pemotongan bahan belum dimulai. Desain yang digabung membuat SPK-nya dibatalkan dengan alasan; desain baru mendapat SPK baru.",
      "Desainer dipilih saat Kasir/CS membuat order Jersey atau DTF. Owner mengatur desainer bawaan per kategori di Pengaturan; Kasir/CS boleh menggantinya atau memilih \"Semua desainer\".",
      "Hanya desainer terpilih yang bisa menekan Mulai di langkah Desain; desainer lain melihat \"Pekerjaan ini untuk …\". Owner/Manager bisa mengalihkan langkah Desain yang masih menunggu ke desainer lain atau membukanya untuk semua desainer (alasan wajib).",
      "Pesanan lama, Digital Print, dan Custom tidak berubah.",
    ],
  },
  {
    versi: "2.20",
    tanggal: "2026-10-26",
    judul: "Riwayat versi desain dan garis progres pesanan",
    untuk: "Kasir/CS, Desain, Owner, Manager, customer",
    butir: [
      "Halaman ACC customer menampilkan garis progres: Desain → Revisi → ACC customer → Produksi → Selesai. Garis yang sama terlihat Kasir/CS di ACC & Mockup (saat baris diklik) dan di Status Order.",
      "\"Selesai\" berarti pesanan siap diambil; setelah diserahkan tertulis \"Sudah diambil\" atau \"Sudah dikirim\".",
      "Setiap desain yang dikirim ke customer diberi nomor versi: v1.0, v1.1, v1.2, … (satu versi = satu putaran sampai customer menjawab). Halaman ACC menampilkan riwayat versi dengan tanggal kirim dan catatan revisi customer per versi.",
      "Versi lama hanya bisa dilihat (tombol Lihat). Yang bisa disetujui hanya versi terbaru.",
      "Persetujuan atau revisi yang dicatat Kasir/CS dari WhatsApp tampil di halaman customer tanpa isi catatan internal (\"Disetujui lewat WhatsApp\").",
      "Setelah desain disetujui, halaman ACC tetap menampilkan progres dan terus memperbarui diri sampai pesanan selesai, dengan tombol \"Lihat status pesanan\".",
      "Panel staf memakai nomor yang sama dengan customer: unggahan ditulis \"#4 = v1.2\"; gambar draf yang diganti sebelum Revisi selesai ditulis \"tidak dikirim\".",
      "Keamanan: gambar mockup lama di link ACC hanya bisa dibuka untuk versi yang memang pernah dikirim ke customer. Draf yang diganti tidak bisa dibuka dengan menebak nomornya.",
    ],
  },
  {
    versi: "2.19",
    tanggal: "2026-10-26",
    judul: "ACC & Mockup lebih ringkas, tombol Revisi selesai, dan halaman ACC customer memperbarui diri",
    untuk: "Kasir/CS, Desain, Owner, Manager, customer",
    butir: [
      "Kotak pencarian: ketik nama customer, nomor SPK (cukup angkanya, mis. 144), atau nomor nota.",
      "Tab dengan jumlah pesanan: Baru masuk, Sudah ada referensi, Sudah upload mockup, Sedang revisi, Revisi H+1, Perlu izin revisi, Sudah disetujui. Bila yang dicari ada di tab lain, halaman menunjukkan tab mana.",
      "Saringan kategori (Jersey/DTF) dan CS, serta urutan: paling lama menunggu (bawaan) atau rencana selesai terdekat.",
      "Satu baris per SPK: nomor SPK & nota, customer, kategori, status, revisi ke berapa, rencana selesai, dan sudah berapa lama menunggu. Klik baris untuk upload mockup, kirim link ACC, gambar referensi, izin revisi, dan riwayat.",
      "Tab Sudah disetujui menampilkan persetujuan customer beberapa hari terakhir (bawaan 7 hari; Owner bisa mengubahnya di Pengaturan). Jersey yang belum di-ACC kasir tetap tampil di sana sampai di-ACC.",
      "Revisi: gambar yang diunggah Desain saat mengerjakan revisi belum terlihat customer. Setelah semua gambar selesai, Desain menekan \"Revisi selesai, kirim ke CS\"; baru saat itu customer melihat mockup baru.",
      "Kasir/CS yang memegang order, Owner, dan Manager mendapat lonceng \"Revisi ke-N SPK … sudah selesai, siap dikirim ke customer\". Kasir/CS dan Manager kini punya lonceng sendiri (hanya pemberitahuan untuk mereka).",
      "Tab baru \"Revisi selesai, belum dikirim\": pesanan pindah ke Sudah upload mockup setelah Kasir/CS menekan Kirim link ACC via WA atau Salin link. Pesan WA revisi memakai template \"Halo Kak, revisi ke-N desain sudah siap…\" yang bisa diubah Owner di menu WhatsApp.",
      "Pengumuman layar produksi \"Revisi SPK … selesai, CS silakan kirim ke customer\" bisa dinyalakan di Suara Layar Produksi (bawaan mati).",
      "Halaman ACC customer memeriksa sendiri sekitar setiap 30 detik tanpa dimuat ulang: menulis \"Desainer sedang mengerjakan revisi ke-N\", lalu saat revisi siap muncul kotak pemberitahuan, bunyi pendek (setelah customer pernah menyentuh halaman), dan judul tab \"(1) Revisi siap\". Pemeriksaan berhenti saat tab disembunyikan.",
    ],
  },
  {
    versi: "2.18.3",
    tanggal: "2026-10-25",
    judul: "Server membangun aplikasi dengan Node.js 24",
    untuk: "Owner / pengelola server",
    butir: [
      "Tampilan, menu, dan data tidak berubah. Yang berubah hanya cara server menyiapkan tampilan aplikasi saat deploy.",
      "Server kini memakai Node.js 24 (masih mendapat perbaikan keamanan sampai April 2028) untuk membangun tampilan aplikasi. Node.js 20 yang lama tetap disimpan sebagai cadangan.",
      "Catatan deploy kini menuliskan versi Node.js yang dipakai, dan folder sementara saat membangun tampilan langsung dihapus setelah selesai.",
    ],
  },
  {
    versi: "2.18.2",
    tanggal: "2026-10-25",
    judul: "Antrean Produksi: Mulai langsung terlihat, alasan penolakan tampil di baris itu",
    untuk: "Semua pos produksi",
    butir: [
      "Setelah menekan Mulai, halaman tidak lagi melompat ke atas. Baris itu langsung berubah menjadi IN_PROGRESS dengan catatan hijau \"Sudah dimulai\". Sebelumnya halaman melompat ke baris-baris atas yang masih Menunggu, sehingga Mulai terlihat seperti tidak bekerja.",
      "Tombol Selesai/Lulus di baris yang baru dimulai menunggu 5 detik, supaya klik kedua yang tidak sengaja tidak langsung menyelesaikan pekerjaan.",
      "Pekerjaan yang dipegang akun lain kini bertuliskan \"Dikerjakan oleh … sejak …\", supaya jelas siapa yang memegangnya. Bila orang itu tidak mengerjakannya, Owner/Manager menekan Alihkan.",
      "Bila tombol Mulai, Selesai, atau Lulus ditolak (misalnya pekerjaan sudah diambil akun lain), alasannya kini tampil merah tepat di bawah tombol di baris itu, dan daftar langsung diperbarui. Sebelumnya pesan hanya muncul di atas halaman sehingga sering tidak terlihat.",
      "Saat menunggu jawaban server, tombol Mulai bertuliskan \"Memulai…\".",
      "Daftar yang diperbarui otomatis setiap 30 detik tidak lagi membuat halaman melompat ke atas.",
    ],
  },
  {
    versi: "2.18.1",
    tanggal: "2026-10-24",
    judul: "Pindah pos dibacakan, Riwayat Produksi pos alternatif, dan alur bawaan terkunci",
    untuk: "Semua pos produksi, Owner, Finance",
    butir: [
      "Riwayat Produksi operator kini juga menampilkan pekerjaan yang diselesaikan lewat pos alternatif (contoh: Press Roll menyelesaikan langkah DTF \"Press Satuan / Press Roll\"), dengan keterangan \"pos alternatif untuk …\".",
      "Menu Workflow: alur bawaan (Banner, DTF, Jersey, mesin Digital Print) tidak bisa dijadikan Configurable dan langkahnya tidak bisa diubah dari menu, supaya QC Jersey tidak hilang dan ubahan tidak hilang saat aplikasi dinyalakan ulang. Pesannya kini memakai bahasa yang mudah dipahami.",
      "Layar produksi kini membacakan SPK yang pindah pos, contohnya \"SPK 4 5 2, pesanan …, pindah ke pos Press.\" Bila dalam 1 menit ada beberapa SPK pindah pos, semuanya digabung menjadi satu pengumuman, contohnya \"3 SPK pindah pos: 2 ke Press, 1 ke Cutting & Jahit\". Pengumuman ini dibacakan setelah reject dan pengumuman manual.",
      "Menu Suara Layar Produksi (Owner/Finance): pilihan pindah pos \"Dibacakan\" (bawaan) atau \"Bunyi pendek saja\", template kalimatnya bisa diubah, dan tetap bisa dimatikan. Layar antrean operator tetap bunyi pendek saja.",
    ],
  },
  {
    versi: "2.18",
    tanggal: "2026-10-24",
    judul: "Buku kas per akun, unduh SPK dari daftar, gambar referensi, dan batas revisi ACC",
    untuk: "Semua kantor, Pattern & Layout",
    butir: [
      "Laporan → Buku kas (siap cetak): pilih Semua akun, Kas Tunai, atau satu rekening bank. Satu akun: saldo awal, transaksi dengan saldo berjalan, saldo akhir, dan nama akun di judul cetak. Semua akun: dikelompokkan per akun dengan subtotal.",
      "Menu SPK: ikon unduh Excel di setiap baris SPK Jersey. Pattern & Layout kini boleh mengunduh, hanya SPK untuk posnya. Setiap unduhan tercatat.",
      "ACC & Mockup: Kasir/CS, Desain, dan Owner bisa menambah gambar referensi desain (maksimal 5 per pesanan). Dilihat Kasir/CS, Desain, Owner, Manager; tidak tampil di SPK, lembar kerja, Excel, halaman ACC customer, maupun nota.",
      "Batas revisi ACC (bawaan 3, diatur Owner di Pengaturan): tampil \"revisi ke-N dari 3\". Revisi berikutnya perlu persetujuan Owner/Manager dengan alasan sebelum mockup baru dikirim.",
      "Revisi yang masuk hari berikutnya ditaruh di antrean revisi (urut waktu masuk) dan SPK diberi tanda \"revisi H+1\". Rencana selesai tidak berubah otomatis.",
    ],
  },
  {
    versi: "2.17.4",
    tanggal: "2026-10-23",
    judul: "Pesan impor Excel memakai nama kolom seperti di file",
    untuk: "Owner, Finance, Manager",
    butir: [
      "Impor stok awal & BOM: pesan \"Rumus Excel tidak diterima\" kini menyebut judul kolom yang tertulis di template, mis. 'Harga beli per satuan' atau 'Jumlah per pcs / m²', bukan nama teknis seperti harga_beli.",
      "Pesan angka yang salah dan daftar perubahan di pratinjau memakai judul kolom yang sama (mis. \"Harga beli per satuan\", \"Nama bahan\").",
      "Impor barang: pesan rumus/formula kini menyebut 'Harga Enduser', 'Aktif', dan seterusnya, sesuai judul kolom file Download Barang.",
    ],
  },
  {
    versi: "2.17.3",
    tanggal: "2026-10-23",
    judul: "Kaki menu samping lebih rapi",
    untuk: "Semua",
    butir: [
      "Kaki menu samping kini tiga baris: \"© 2026 SOQPRINT. All Rights Reserved.\", \"Powered by iartech.\", lalu nomor versi (mis. v2.17.3). Kata SOQPRINT tidak lagi muncul dua kali.",
      "Nomor versi tetap bisa diklik untuk membuka halaman Catatan pembaruan, di komputer maupun di HP. Halaman login dan halaman customer memakai tulisan yang sama.",
    ],
  },
  {
    versi: "2.17.2",
    tanggal: "2026-10-23",
    judul: "Nama pos yang mudah dibaca + tabel Antrean Produksi lebih rapi",
    untuk: "Owner, Manager, Operator, QC",
    butir: [
      "Pos produksi tampil dengan namanya (mis. \"Press Satuan / Press Roll\"), bukan kode seperti OP_PRESS_SATUAN — di Antrean Produksi (tabel, tampilan HP, detail SPK, form Reject QC, catatan rework), Riwayat Produksi, menu SPK, filter Monitoring, halaman Workflow, dan lonceng \"QC reject\".",
      "Tabel Antrean Produksi: kolom \"Masuk pos / SPK dibuat\" tidak lagi terpotong per kata, dan kolom Aksi selalu terlihat di sisi kanan saat tabel digeser (seperti menu Nota).",
      "Paket ini juga membawa perbaikan skrip v2.17.1 ke server.",
    ],
  },
  {
    versi: "2.17.1",
    tanggal: "2026-10-23",
    judul: "Perbaikan skrip merapikan harga nota Jersey (diskon baris penutup selisih)",
    untuk: "Owner, Finance, pengelola server",
    butir: [
      "Dry-run skrip rapikan harga kini menampilkan total sesudah dirapikan dengan benar bila selisih harga dulu ditutup dengan diskon baris: total tetap, tidak ada lagi peringatan palsu \"dibayar melebihi total baru\".",
      "Diskon nota yang kebetulan sama besar dengan selisih tidak ikut dihapus bila selisih itu sudah ditutup diskon baris (diskon nota itu dianggap promo dan tetap).",
      "Tidak ada perubahan pada halaman aplikasi.",
    ],
  },
  {
    versi: "2.17",
    tanggal: "2026-10-23",
    judul: "Lapor masalah dari semua pos + daftar alasan reject",
    untuk: "Operator, QC, Manager, Owner",
    butir: [
      "Setiap pos (kecuali Desain sebagai pos pertama) punya tombol \"Lapor masalah\" di Antrean, untuk pekerjaan yang sudah sampai di pos itu (menunggu) maupun yang sedang dikerjakan sendiri. QC tetap memakai tombol Reject.",
      "Isi laporan: pos tujuan (bawaan pos tepat sebelumnya, boleh pos lebih awal), item/jumlah (Jersey: pcs, per baris variasi bila ada), alasan dari tombol cepat, dan keterangan (wajib bila \"Lainnya\"); sebelum terkirim ditanya sekali lagi.",
      "Cara kerjanya sama dengan reject QC: pos tujuan sampai pos sebelum pelapor mengerjakan ulang jumlah yang dilaporkan; pos pelapor menunggu, lalu mengerjakan semuanya. Penjahit melapor dari bagiannya: bagiannya berkurang, pcs perbaikan kembali sebagai bagian baru setelah Press; bagian penjahit lain tetap jalan.",
      "Alasan tampil di antrean pos tujuan dan di kartu layar produksi, serta dibacakan lengkap (dari pos mana, ke pos mana, alasan). Owner mendapat lonceng; semua tercatat di audit dan Riwayat Produksi. Aturan upah borongan dan potong bahan rework tidak berubah.",
      "Daftar alasan (Salah cetak, Warna tidak sesuai, Ukuran salah, Jahitan rusak, Noda/kotor, Bahan cacat, Lainnya) diatur Owner di halaman Layar produksi & kode TV: ubah nama, tambah, matikan (tidak bisa dihapus). Form Reject QC memakai daftar yang sama.",
    ],
  },
  {
    versi: "2.16",
    tanggal: "2026-10-23",
    judul: "Layar produksi lanjutan (A): timer per pos, bunyi pindah pos, reject dibacakan lengkap",
    untuk: "Operator, QC, Manager, Owner, Finance",
    butir: [
      "Timer berjalan di kartu Antrean (pekerjaan yang sedang dikerjakan) dan di layar produksi, sejak Mulai sampai Selesai; durasi (menit:detik) tersimpan di Riwayat Produksi. Belum ada target waktu.",
      "Saat pekerjaan baru masuk ke sebuah pos: satu bunyi pendek di layar produksi dan di layar Antrean pos itu (tidak dibacakan). Di layar Antrean bunyi aktif setelah sentuhan pertama dan bisa dimatikan per perangkat (tombol Bunyi).",
      "Reject dibacakan lengkap di layar produksi dengan nada peringatan dan prioritas tertinggi: nomor SPK, pemesan, item, jumlah, pos asal, pos tujuan perbaikan, dan alasan; dibacakan 2 kali (bisa diatur 1–3).",
      "Menu Suara Layar Produksi (Owner/Finance): saklar timer (layar produksi / antrean), saklar bunyi pindah pos, jumlah ulang bacaan reject, template Reject dengan kata isian baru {item} {qty} {pos_asal} {pos_tujuan} {alasan}.",
      "Lapor masalah dari semua pos dengan pilihan alasan menyusul di paket berikutnya (v2.16-B).",
    ],
  },
  {
    versi: "2.15",
    tanggal: "2026-10-22",
    judul: "Layar produksi dari rumah (WFH): izin per akun, catatan akses, cabut perangkat satu per satu",
    untuk: "Owner, Manager, akun yang diberi izin",
    butir: [
      "Menu Users: kolom \"Layar produksi\" — Owner menentukan akun mana yang boleh membuka layar produksi dengan login (dari rumah atau HP). Bawaan: Owner dan Manager. Akun yang boleh mendapat tautan \"Layar produksi\" di menu Produksi.",
      "Akun tanpa izin yang membuka layar ditolak server dan diberi keterangan \"minta izin ke Owner\" (atau masukkan kode TV). Akun nonaktif atau di Sampah otomatis kehilangan akses.",
      "Owner melihat siapa yang membuka layar lewat akun (satu catatan per akun per hari: pertama, terakhir, berapa kali, alamat; disimpan 180 hari) di halaman Layar produksi & kode TV.",
      "Perangkat berkode (TV/HP) bisa diberi nama saat memasukkan kode; Owner melihat daftarnya dan mencabut satu per satu tanpa mengganggu perangkat lain. Cabut kode (semua) tetap ada. Semua tercatat di audit log.",
      "Skrip pengelola rapikan_harga_revisi: opsi baru untuk mengurangi diskon nota sebesar nominal tertentu (dry-run dulu; menolak bila total berubah).",
    ],
  },
  {
    versi: "2.14",
    tanggal: "2026-10-22",
    judul: "Hapus akun ke Sampah, pulihkan, hapus permanen",
    untuk: "Owner, Manager",
    butir: [
      "Menu Users: tombol Hapus memindahkan akun ke Sampah (alasan wajib). Akun itu hilang dari daftar dan semua pilihan operator/kasir, tidak bisa login, semua sesinya langsung putus; riwayat nota, pembayaran, upah, dan produksi tetap utuh; username tidak bisa dipakai ulang.",
      "Tab Sampah: Pulihkan mengembalikan akun sebagai Nonaktif; saat diaktifkan lagi, pemiliknya wajib mengganti password pada login berikutnya.",
      "Hapus permanen hanya Owner, hanya dari Sampah, dan hanya akun yang belum pernah dipakai sama sekali (server memeriksa jejak di audit log, nota, pembayaran, kas, produksi, upah, stok, login). Akun yang dibuat sebelum versi ini tidak bisa dihapus permanen.",
      "Manager hanya bisa menghapus/memulihkan akun operator, Desain, dan Kasir/CS. Akun Owner tidak bisa dihapus. Semua tindakan tercatat di audit log.",
      "Aplikasi mencatat waktu login pertama dan terakhir tiap akun (tanpa password).",
    ],
  },
  {
    versi: "2.13",
    tanggal: "2026-10-22",
    judul: "Rincian pembayaran di laporan penjualan, pembayaran masuk per tanggal, menu Nota",
    untuk: "Owner, Finance, Kasir/CS",
    butir: [
      "Laporan Penjualan: tombol Riwayat di tiap faktur membuka urutan pembayarannya (tanggal, jenis DP / cicilan / pelunasan / koreksi, cara bayar, nominal, dicatat oleh, sisa setelahnya).",
      "Menu Riwayat Pembayaran: ringkasan \"Pembayaran masuk per tanggal\" (DP + cicilan, pelunasan, koreksi, pengembalian, per cara bayar). Kasir/CS kini bisa membukanya, hanya untuk hari ini (dibatasi server) dan hanya melihat. Laporan Pelunasan untuk Kasir/CS tetap seperti sebelumnya (boleh memilih rentang tanggal).",
      "Menu Nota: kotak pencarian (nota, order, SPK, customer); kolom Aksi tetap menempel di kanan saat tabel digeser di HP; tautan \"Buka nota\" dari panel faktur di Riwayat Pembayaran (Owner juga \"Buka di Pembayaran\").",
    ],
  },
  {
    versi: "2.12",
    tanggal: "2026-10-22",
    judul: "Operator hanya melihat SPK untuk posnya sendiri",
    untuk: "Semua operator produksi, QC, penjahit; Owner",
    butir: [
      "Menu SPK untuk operator kini hanya berisi SPK untuk pos sendiri: sedang dikerjakan, akan datang (termasuk yang masih di pos sebelumnya), dan yang langkah posnya selesai beberapa hari terakhir. Daftar semua SPK tidak ada lagi untuk operator; SPK lain tidak bisa dibuka (juga lembar kerjanya).",
      "Penjahit hanya melihat SPK yang bagian jahitnya sudah dibagikan kepadanya. QC melihat SPK yang langkah QC-nya sedang, akan datang, atau baru selesai.",
      "Desain, Kasir/CS, Finance, Manager, dan Owner tetap melihat semua SPK seperti sebelumnya.",
      "Pengaturan Owner: berapa hari SPK yang sudah selesai masih tampil untuk operator (bawaan 7 hari).",
      "Pembatasan dilakukan di server, bukan hanya disembunyikan di tampilan.",
    ],
  },
  {
    versi: "2.11.3",
    tanggal: "2026-10-22",
    judul: "Pemeriksaan server untuk HSTS/CSP dan nama file template stok awal",
    untuk: "Owner, Finance, pengelola server",
    butir: [
      "Nama file template stok awal & BOM memakai tanggal zona toko (WIT), bukan UTC; unduhan dini hari tidak lagi bertanggal kemarin.",
      "Pemeriksaan server tiap 30 menit kini memastikan header keamanan HSTS 6 bulan dan CSP mode blokir terkirim di app.soqdigitalprint.com dan soqdigitalprint.com; bila hilang, pengelola mendapat peringatan.",
      "Skrip nginx server: pemasangan ulang dan konfigurasi darurat membawa HSTS/CSP yang aktif, HSTS hanya dinyatakan aktif bila barisnya benar-benar tertulis, dan pesan lebih jelas bila snippet belum ada.",
      "Tidak ada perubahan pada halaman aplikasi.",
    ],
  },
  {
    versi: "2.11.2",
    tanggal: "2026-10-21",
    judul: "Diskon baris saat merapikan nota yang produksinya sudah berjalan",
    untuk: "Owner, Finance, pengelola server",
    butir: [
      "Skrip rapikan_harga_revisi mendapat opsi --diskon-baris KODE=RUPIAH dan --alasan-diskon: Owner bisa menggratiskan atau memotong satu baris (misalnya kerah tambahan) dalam koreksi yang sama, karena tombol Ubah data terkunci setelah ACC dan membukanya akan mengulang ACC produksi.",
      "Potongan itu dicatat sebagai diskon baris dengan alasan, bukan pembayaran: tidak masuk buku kas, tampil di laporan Harga khusus & diskon dengan nama Owner yang memberinya, dan tercatat di audit log.",
      "Dry-run skrip memperingatkan bila jumlah yang sudah dibayar melebihi total baru, supaya koreksi pembayaran Owner dilakukan lebih dulu.",
    ],
  },
  {
    versi: "2.11.1",
    tanggal: "2026-10-21",
    judul: "Harga nota lama tidak lagi berubah saat pesanan Jersey diubah",
    untuk: "Owner, Finance, Kasir/CS",
    butir: [
      "Perbaikan: tombol Ubah data pada pesanan Jersey sebelumnya menghitung ulang semua baris dari harga master saat itu. Nota lama bisa berubah total dan muncul piutang setelah Owner mengubah harga master. Sekarang barang yang sudah ada di nota tetap memakai harga saat nota dibuat; hanya barang baru yang memakai harga master sekarang.",
      "Perubahan harga master hanya berlaku untuk nota baru. Nota Digital Print, DTF, dan Custom memang tidak pernah dihitung ulang.",
      "Riwayat revisi nota kini menyimpan baris lama beserta harganya. Diskon yang ditambahkan saat revisi mencatat siapa yang menambahkannya; laporan Penjualan dan laporan Harga khusus & diskon menampilkannya di samping nama Kasir/CS pembuat nota.",
      "Owner dan pengelola: skrip cek_harga_revisi (hanya membaca) mendaftar nota yang harganya terlanjur berubah; skrip rapikan_harga_revisi (dry-run, lalu per nota atas persetujuan Owner) mengembalikan harga asli dan menghapus diskon penutup selisih. Pembayaran dan buku kas tidak disentuh.",
    ],
  },
  {
    versi: "2.11",
    tanggal: "2026-10-19",
    judul: "Label termal di komputer QC dan impor stok awal & BOM",
    untuk: "Owner, Finance, QC, operator Outdoor dan DTF",
    butir: [
      "Menu Produksi, Antrean Label (QC dan Owner): label 100 × 150 mm masuk otomatis saat Selesai di pos Outdoor, langkah DTF terakhir, dan QC Jersey Lulus. Tekan Cetak lalu Enter di dialog cetak; label yang sudah dicetak bisa dicetak ulang dan tercatat.",
      "Label berisi QR, nomor SPK besar, faktur, nama customer, nama CS, rincian barang (Jersey: tim, total pcs, ukuran), dan tanggal selesai. Tanpa harga, nomor HP, atau nama pemain. QR membuka halaman SPK di aplikasi (wajib login).",
      "Owner bisa menyalakan atau mematikan label per pos di halaman Antrean Label. Halaman Uji printer berisi label contoh dan langkah uji printer di toko.",
      "Menu Stok, tab Impor stok awal & BOM (Owner dan Finance): unduh template Excel, isi bahan, stok awal, harga beli, dan BOM, lalu periksa dan terapkan. Stok awal dicatat sebagai mutasi \"Stok awal\" sekali per bahan.",
      "Pratinjau menandai setiap baris Baru, Diubah, Sama, atau Bermasalah. Baris Bermasalah tidak diterapkan, misalnya rumus Excel, kode bahan sama dengan kode barang, atau bahan yang sudah punya mutasi. Kode bahan kosong dibuat otomatis (BHN-xxxx).",
      "Data lama dibackup otomatis sebelum diterapkan; Owner bisa mengembalikan impor dari riwayat.",
    ],
  },
  {
    versi: "2.10",
    tanggal: "2026-10-19",
    judul: "Suara layar produksi seperti pengingat manager",
    untuk: "Owner, Finance, Manager, semua pos produksi",
    butir: [
      "Layar produksi membacakan pengingat berkala (bawaan setiap 30 menit): per pos yang ada pekerjaan disebut jumlah antrean, siapa yang sedang mengerjakan, dan tunggakan yang lewat rencana selesai (paling banyak 3 per pos, sisanya \"dan N lainnya\"). Pesanan yang tertahan menunggu ACC, DP, atau stok disebut di akhir. Pos tanpa pekerjaan dilewati.",
      "Pengingat dibatasi sekitar 90 detik. Bila terlalu panjang, pos dengan tunggakan terbanyak didahulukan. Pengingat tidak memotong pengumuman lain dan mengalah pada reject QC, deadline, SPK baru, jadwal, dan pengumuman manual.",
      "Bunyi pembuka sebelum setiap pengumuman, dengan 3 pilihan nada, volume, dan saklar. Reject QC memakai nada tegas yang berbeda.",
      "Owner dan Finance bisa mengubah kata-kata setiap pengumuman (template), mendengar contoh, dan mengembalikan ke teks bawaan. Pengaturan ada di Monitoring, Layar produksi & kode TV (Finance: menu Pengaturan, Suara Layar Produksi).",
      "Owner, Finance, dan Manager bisa mengetik pengumuman manual: sekarang atau pada jam tertentu, diulang sampai 3 kali, dan bisa dibatalkan pembuatnya atau Owner.",
      "Teks pengumuman terakhir tampil di bilah bawah layar produksi. Kode akses TV tetap hanya Owner.",
    ],
  },
  {
    versi: "2.9",
    tanggal: "2026-10-18",
    judul: "Nomor versi dan catatan pembaruan",
    untuk: "Semua peran",
    butir: [
      "Nomor versi aplikasi tampil di kaki menu samping (contoh: SOQPRINT v2.9). Klik untuk membuka halaman ini.",
      "Halaman Catatan pembaruan ini: ringkasan perubahan per versi dalam bahasa sederhana, bisa dibuka semua peran.",
      "Aturan nomor: fitur baru menaikkan angka kedua (2.9 → 2.10), perbaikan saja menaikkan angka ketiga (2.9 → 2.9.1), perubahan besar menaikkan angka pertama (3.0).",
      "Untuk pengelola server: version.json memuat nomor versi bersama kode rilis; hasil deploy menyebutkan nomor versi.",
    ],
  },
  {
    versi: "2.8",
    tanggal: "2026-10-17",
    judul: "Transfer kas antar akun",
    untuk: "Owner, Finance",
    butir: [
      "Buku Kas: tab baru \"Transfer antar akun\" untuk memindahkan saldo Kas Tunai ke rekening bank dan sebaliknya. Satu transfer membuat dua entri yang saling terhubung dengan satu nomor TRF.",
      "Transfer tidak dihitung sebagai pemasukan atau pengeluaran di Buku Kas, Laporan Arus Kas, dan Dashboard. Biaya admin bank (bila diisi) dicatat sebagai pengeluaran terpisah.",
      "Pembatalan transfer hanya oleh Owner dengan alasan, membalik kedua entri sekaligus. Saldo akun asal yang kurang hanya memberi peringatan.",
    ],
  },
  {
    versi: "2.7",
    tanggal: "2026-10-17",
    judul: "Layar produksi, kode TV, template Excel Jersey, perbaikan kas pembelian",
    untuk: "Owner, Manager, Kasir/CS, Finance, ruang produksi",
    butir: [
      "Menu Monitoring punya tombol Layar produksi untuk TV ruang produksi (dengan kode akses perangkat) dan halaman Atur layar & kode TV. TV depan juga dikunci dengan kode yang sama.",
      "Form Jersey: tombol Hitung tetap menampilkan harga saat stok bahan kurang (pesanan menunggu stok), dan tombol Unduh template Excel untuk daftar nama & nomor pemain.",
      "Pembelian yang sudah dibayar lalu dibatalkan: pilihan \"uang belum keluar, kembalikan ke kas\" atau \"diurus di luar sistem\". Pembelian yang terlanjur batal bisa dikembalikan uangnya ke kas.",
      "Finance mendapat menu Price List (tanpa HPP) dan tab Kategori Kas.",
    ],
  },
  {
    versi: "2.6",
    tanggal: "2026-10-17",
    judul: "Penilaian customer, ajakan menilai lewat WhatsApp, kode barang dan bahan terpisah",
    untuk: "Owner, Manager, Kasir/CS, QC",
    butir: [
      "Customer dapat memberi penilaian bintang lewat nota digital setelah pesanan diambil; Owner dan Manager melihatnya di menu Masukan Customer. Nilai rendah memberi lonceng peringatan.",
      "Setelah pesanan diambil, pesan WhatsApp mengajak customer menilai.",
      "Kode barang dan kode bahan tidak boleh sama; kode bahan kosong dibuat otomatis (BHN-0001, dst.).",
      "Sakelar \"Wajib ACC customer\" terpisah untuk DTF dan Jersey. Teks Reject QC untuk penjahit diperjelas.",
    ],
  },
  {
    versi: "2.5.1",
    tanggal: "2026-10-16",
    judul: "Pemeliharaan server",
    untuk: "Pengelola server",
    butir: [
      "Hasil deploy selalu tertulis di baris terakhir (BERHASIL atau GAGAL) dan tersimpan di catatan; koneksi SSH yang putus tidak menghentikan deploy.",
      "Pembaruan keamanan server dan database. Tidak ada perubahan tampilan aplikasi.",
    ],
  },
  {
    versi: "2.5",
    tanggal: "2026-10-15",
    judul: "Tambahan Oktober: nama CS, bantuan kendala, pengingat tagihan, lembar kerja A4",
    untuk: "Semua peran",
    butir: [
      "Nama Kasir/CS tampil di transaksi dan bisa difilter. Kasir/CS dapat membuat customer Reseller dan Member.",
      "Tombol Bantuan di setiap halaman: panduan sesuai peran dan laporan kendala ke Tim iartech.",
      "Mockup Jersey sampai 6 gambar; semua pos melihat semua SPK; penjahit melihat nama pemain.",
      "Lembar kerja A4 di layar dan unduh Excel (Owner, Manager, Finance); pengingat tagihan; Riwayat Pembayaran untuk Finance.",
    ],
  },
  {
    versi: "2.4",
    tanggal: "2026-10-13",
    judul: "Lembar kerja SPK Jersey",
    untuk: "Owner, Manager, produksi",
    butir: [
      "SPK Jersey tampil sebagai lembar kerja A4 dan bisa diunduh ke Excel, susunan seperti contoh dari Owner.",
      "Nama pemain hanya untuk peran yang membutuhkan; bagian Jahit melihat rekap ukuran.",
    ],
  },
  {
    versi: "2.3",
    tanggal: "2026-10-12",
    judul: "Dashboard Owner baru dan perbaikan dari bahan panduan",
    untuk: "Owner, Manager, Kasir/CS, QC",
    butir: [
      "Dashboard Owner versi baru dengan ringkasan harian, produksi per pos, dan uang masuk.",
      "Delapan perbaikan dari pembuatan panduan: alasan tertahan tampil di antrean dan monitoring, centang semua checklist Jersey, lepas paksa hanya Owner, pesan Set READY DTF, dan lainnya.",
    ],
  },
  {
    versi: "2.2",
    tanggal: "2026-10-12",
    judul: "Harga khusus, peran Manager, unduh dan impor barang",
    untuk: "Owner, Manager, Kasir/CS",
    butir: [
      "Harga khusus per transaksi dengan alasan dan batas untuk Member; laporan harga khusus dan diskon untuk Owner.",
      "Peran baru Manager: pengawas produksi tanpa melihat uang, bisa mengalihkan pekerjaan dan mengelola akun karyawan.",
      "Master barang bisa diunduh ke Excel dan diimpor kembali.",
    ],
  },
  {
    versi: "2.1",
    tanggal: "2026-10-12",
    judul: "Price List",
    untuk: "Owner, Kasir/CS",
    butir: [
      "Menu Price List: daftar harga Enduser, Reseller, dan Member yang bisa dicari, tanpa HPP.",
    ],
  },
  {
    versi: "2.0.1",
    tanggal: "2026-10-10",
    judul: "Perbaikan kecil hasil audit",
    untuk: "Semua peran",
    butir: [
      "Paket perbaikan kecil dari audit sebelum pemakaian penuh, tanpa perubahan alur kerja. Pembaruan keamanan server.",
    ],
  },
  {
    versi: "2.0",
    tanggal: "2026-10-10",
    judul: "Tampilan baru SOQPRINT",
    untuk: "Semua peran",
    butir: [
      "Tampilan terang dengan menu samping biru dan tombol oranye, halaman login baru, halaman customer dan TV disesuaikan, invoice A4, ikon aplikasi oranye.",
      "Sebelum ini: v1.0 rilis awal (7 Oktober), v1.1 perbaikan hasil audit dan DTF meter lari, v1.2 tarif borongan per jenis jahitan.",
    ],
  },
];

// urutan bagian nomor untuk membandingkan "2.10" > "2.9"
const bagian = (v) => String(v).split(".").map((x) => parseInt(x, 10) || 0);
export function bandingVersi(a, b) {
  const pa = bagian(a); const pb = bagian(b);
  for (let i = 0; i < Math.max(pa.length, pb.length); i += 1) {
    const d = (pa[i] || 0) - (pb[i] || 0);
    if (d) return d;
  }
  return 0;
}

// entri terbaru dulu, apa pun urutan penulisannya
export const urutTerbaru = (daftar = CATATAN) => [...daftar].sort((x, y) => bandingVersi(y.versi, x.versi));
export const terbaru = (daftar = CATATAN) => urutTerbaru(daftar)[0] || null;

// jenis kenaikan dari versi lama ke baru: "besar" | "fitur" | "perbaikan" | null (tidak naik)
export function jenisKenaikan(lama, baru) {
  const a = bagian(lama); const b = bagian(baru);
  if (b[0] > a[0]) return "besar";
  if (b[0] === a[0] && (b[1] || 0) > (a[1] || 0)) return "fitur";
  if (b[0] === a[0] && (b[1] || 0) === (a[1] || 0) && (b[2] || 0) > (a[2] || 0)) return "perbaikan";
  return null;
}
